import useGetStickyState from 'hooks/search/useGetStickyState';
import useSearchRefetch from 'hooks/search/useSearchRefetch';
import useModal from 'hooks/useModal';
import CoreSearchInput from 'shared/input/CoreSearchInput';
import useCommonStore from 'store/useCommonStore';
import { StickySectionHeaderRow } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';

const SearchInputRow = ({ bg_dom }: { bg_dom: HTMLElement | null }) => {
	// store
	const { setSearchModal, keyword } = useCommonStore();

	// hooks
	const [setModalPosition] = useModal(setSearchModal);
	useSearchRefetch();
	const [is_sticky, headerRowRef] = useGetStickyState(bg_dom);

	return (
		<StickySectionHeaderRow
			_padding="16px"
			radius={is_sticky ? '0' : '16px 16px 0 0'}
			sticky_top="-16px"
			ref={headerRowRef}
		>
			<style.Grid flex="center">
				<CoreSearchInput
					input_id="total-search-button"
					_width="640px"
					_value={keyword}
					_onChange={() => undefined}
					_onClick={(e) =>
						setModalPosition(e.currentTarget, ['top_inner', 'left_center'], [-16, 0])
					}
					_placeholder="계정명, 채널명, 브랜드명 등 키워드를 입력해주세요."
				/>
			</style.Grid>
		</StickySectionHeaderRow>
	);
};

export default SearchInputRow;
